import { Moment } from 'moment';

export class ImageObj {
    id: number;
    content: File;
    description: string;
    dated: Moment;
    format: string;
}